import gql from 'graphql-tag';

export const SELF_ENROLLMENT = gql`
  mutation selfEnrollPatient($input: SelfEnrollPatientData!) {
    selfEnrollPatient(input: $input) {
      success
      message
      resetToken
    }
  }
`;

export const VALIDATE_SELF_ENROLLMENT_PATIENT_IDENTITY = gql`
  mutation validateSelfEnrollmentPatientIdentity($input: ValidateSelfEnrollmentPatientData!) {
    validateSelfEnrollmentPatientIdentity(input: $input) {
      success
      message
      patientInformation {
        name
        deactivationReason
        phoneNumber
        email
        patientId
        attemptId
      }
    }
  }
`;
